'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_TestingPage$TestResult(detail, error) {
  this.SS = null;
  this.ST = null;
  this.SS = detail;
  this.ST = error;
}
export { $c_Lmealorama_pages_TestingPage$TestResult as $c_Lmealorama_pages_TestingPage$TestResult };
$p = $c_Lmealorama_pages_TestingPage$TestResult.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_TestingPage$TestResult;
/** @constructor */
function $h_Lmealorama_pages_TestingPage$TestResult() {
}
export { $h_Lmealorama_pages_TestingPage$TestResult as $h_Lmealorama_pages_TestingPage$TestResult };
$h_Lmealorama_pages_TestingPage$TestResult.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 1874964649, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_TestingPage$TestResult)) {
    if ((this.SS === x$0.SS)) {
      var x = this.ST;
      var x$2 = x$0.ST;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 2;
});
$p.r = (function() {
  return "TestResult";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.SS;
  }
  if ((n === 1)) {
    return this.ST;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_pages_TestingPage$TestResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kI)));
}
export { $isArrayOf_Lmealorama_pages_TestingPage$TestResult as $isArrayOf_Lmealorama_pages_TestingPage$TestResult };
var $d_Lmealorama_pages_TestingPage$TestResult = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_TestingPage$TestResult, "mealorama.pages.TestingPage$TestResult", ({
  kI: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_TestingPage$TestResult as $d_Lmealorama_pages_TestingPage$TestResult };
//# sourceMappingURL=mealorama.pages.-Testing-Page$-Test-Result.js.map
